import { AppSettings } from './../shared/app-settings';
import { LoadingSpinnerService } from './../shared/services/loading-spinner.service';
import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService, private loader:LoadingSpinnerService ) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      //some urls do not need bearer
      
    if(!this.UrlsWithoutAuth.some((i)=>{ return request.url==i}) ){
        request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${this.auth.getToken()}`
            }
          });
    }    
    this.loader.showSpinner();
    return next.handle(request);
  }

  private UrlsWithoutAuth:string[]=[
    AppSettings.endpoints.users.login,
    AppSettings.endpoints.users.register,
    AppSettings.endpoints.users.launch,
    AppSettings.endpoints.system.programs
  ]
}


// WEBPACK FOOTER //
// ./src/app/auth/token.interceptor.ts